<section class="db-single-page-creation-step" [formGroup]="pageForm">
  <div class="db-left-side" *ngIf="!isMobile">
    <div>
      <i class="db-icon db-icon-ds-ai-generate fadeIn"></i>

      <div class="db-header mb10" textSlideUp data-animate="slideUp1" [animationDuration]="500" [delay]="90">
        Let’s start creating<br/>
        your page with AI
      </div>

      <div class="db-desc" textSlideUp data-animate="slideUp2" [animationDuration]="400" [delay]="60">
        Answer a few questions and our AI will generate a personalized<br>
        page with tailored content and images.
      </div>
    </div>
  </div>

  <div class="db-right-side">
    <div class="actions-header-container">
      <div class="actions-header">What's your page about?</div>
      <div class="actions-header-desc">This helps us guide your experience.</div>
    </div>
    <div class="ds-input-wrap mb10">
      <div class="ds-textarea-label-wrap with-enhance">
        <span class="field-label">{{'text_enterPageTitle' | dbText}}</span>
      </div>
      <input
        [placeholder]="'text_enterYourPageTitle' | dbText"
        [formControlName]="'title'"
        class="ds-input ds-input-black"/>
      <span class="ds-input-error-msg" *ngIf="pageForm.get('title').touched && pageForm.get('title').invalid">
        {{'text_fillFnField' | dbText}}
      </span>
    </div>
    <div class="ds-input-wrap">
      <div class="ds-textarea-label-wrap with-enhance">
        <span class="field-label">Describe your page</span>
      </div>
      <textarea [attr.maxLength]="1000"
                placeholder="Describe your page

Ex. A brief company introduction. Include team member bios and their roles, with a friendly and professional tone."
                [formControlName]="'description'"
                class="ds-textarea ds-textarea-black no-resize"
                rows="6"></textarea>
      <span class="ds-input-error-msg" *ngIf="pageForm.get('description').touched && pageForm.get('description').hasError('required')">
        This field is required
      </span>
      <span class="ds-input-error-msg" *ngIf="pageForm.get('description').touched && pageForm.get('description').hasError('minlength')">
        To get better results input no less than 20 symbols.
      </span>
    </div>
  </div>

  <div class="db-actions-line">
    <a class="ds-btn-black rectangle"
       (click)="onClickNext()"
       [ngClass]="{'ds-btn-disabled': pageForm.invalid}">
      <span>Next</span>
    </a>
  </div>
</section>

